<div class="reg-date">{{ (date | date: 'dd MMM yyyy') || '-' }}</div>
